<template>
  <div class="leaders__events" :style="{ '--apperances-color': computedColor }">
    <div
      class="leaders-event"
      v-for="(event) in events"
      :key="event.id"
    >
      <div class="leaders-event__header">
        <div class="leaders-event__top pb-4 pt-4 flex-wrap">
          <div class="d-flex align-items-center">
            <div class="pr-1">
              <link-event 
                class="event-title"
                :round="event.rounds[0]"
              >
                {{ event.name.toUpperCase() }}
              </link-event>
            </div>
            <div class="leaders__count">
              ({{ event.count_runs_in_first_round }})
            </div>
          </div>

          <round-tabs :tabs="event.rounds" :event="event" />
        </div>

        <div class="leaders-event__judge-name">
          Judges: {{ event.judges.map(j => j).join(', ') }}
        </div>

        <div class="leaders-event__scores-tracker">
          {{ event.score_line }}
        </div>
      </div>

      <div class="leaders-event__body active" data-content="0">
        <ul class="leaders-event__main-row">
          <li class="col-1 tac">Rank</li>
          <li class="col-9 display-mob">Info</li>
          <li class="col-3 hidden-mob">Rider name</li>
          <li class="col-3 hidden-mob">Horse name</li>
          <li class="col-3 hidden-mob">Owner name</li>
          <li class="col-2 tac">Score</li>
        </ul>

        <ul v-for="(draw, idx) in event.draws" :key="draw.id">
          <li class="col-1 tac">{{ idx + 1 }}</li>
          <li class="col-9 display-mob">
            <div><span>Rider name:</span> <link-rider :draw="draw" /></div>
            <div><span>Horse name:</span> {{ draw.horse_name }}</div>
            <div><span>Owner name:</span> {{ draw.owner_name }}</div>
          </li>
          <li class="col-3 hidden-mob"> <link-rider :draw="draw" /></li>
          <li class="col-3 hidden-mob">{{ draw.horse_name }}</li>
          <li class="col-3 hidden-mob">{{ draw.owner_name }}</li>
          <li class="col-2 tac">{{ draw.totals_sum }}</li>
        </ul>

        <ul v-for="p in 10 - event.draws.length" :key="p + event.draws.length">
          <li class="col-1 tac">{{ p + event.draws.length }}</li>
          <li class="col-9 display-mob"></li>
          <li class="col-3 hidden-mob"></li>
          <li class="col-3 hidden-mob"></li>
          <li class="col-3 hidden-mob"></li>
          <li class="col-2 tac"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import fetchData from '../../../../mixins/apiHelpers'
import RoundTabs from './RoundTabs'
import LinkRider from './Links/LinkRider'
import LinkEvent from './Links/LinkEvent'

export default {
  inject: ['entity'],
  components: {
    'round-tabs': RoundTabs,
    'link-rider': LinkRider,
    'link-event': LinkEvent
  },
  data() {
    return {
      events: []
    }
  },
  props: {
    appearances: {
      type: Object,
      required: false
    }
  },
  computed: {
    computedColor() {
      return this.appearances && this.appearances.schema_color
        ? `${this.appearances.schema_color}`
        : 'var(--primary)'
    }
  },
  methods: {
    getDraftsInfo() {
      fetchData(`${this.$api}/leaders/drafts/${this.entity.id}/events`, (response) => {
        this.events = response.data.data.events
      }, this)
    }
  },
  mounted() {
    this.getDraftsInfo()
  }
}
</script>

<style scoped>
  .leaders a {
    color: var(--apperances-color) !important;
  }

  .leaders__count {
    color: var(--apperances-color) !important;
  }

  .leaders__tabs {
    border-color: var(--apperances-color) !important;
  }

  .leaders__tab {
    color: var(--apperances-color) !important;
    border-left-color: var(--apperances-color) !important;
  }

  .leaders .leaders__tab.active {
    background-color: var(--apperances-color) !important;
    color: var(--white) !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/DraftEventsList.vue